import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResetURLComponent } from './reset-url.component';

const routes: Routes = [
  {
    path: '',
    component:ResetURLComponent
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResetRoutingModule { }
